export const photoOutlet = 'photo';
